<script setup>
/* eslint-disable */
</script>
<template>
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.57884 6.58815L6.59134 9.57565C6.51395 9.65313 6.42204 9.7146 6.32088 9.75653C6.21971 9.79847 6.11127 9.82006 6.00176 9.82006C5.89225 9.82006 5.78381 9.79847 5.68264 9.75653C5.58148 9.7146 5.48957 9.65313 5.41217 9.57565L1.83301 6.00065V1.83398H5.99967L9.57884 5.41315C9.73405 5.56929 9.82117 5.7805 9.82117 6.00065C9.82117 6.22081 9.73405 6.43202 9.57884 6.58815Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.91699 3.91602H3.92199"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped lang="scss">

</style>